if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

       this.updateSubProductInput();

      const formData = new FormData(this.form);



        // Fetch current cart contents
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              if (formData.get('offered')){
                let variantId = +formData.get('id');
                // Array to store already existing token IDs
                const existingTokenIds = [];

                // Check if any of the active items are already in the cart
                const existingItem = cart.items.find(cartItem =>
                    cartItem.id === variantId
                );

                if (existingItem) {
                  // If an item with the same Id is already in the cart, add the token ID to the list
                  existingTokenIds.push(variantId);
                }

                if (existingTokenIds.length > 0) {
                  var messagePurchase = this.submitBtn.getAttribute('data-msg-only-purchase');
                  showToast(messagePurchase, 'error');
                  this.submitBtn.removeAttribute('aria-disabled');
                  setTimeout(() => {
                    this.submitBtn.classList.remove('is-loading');
                    this.submitBtn.classList.remove('is-success');
                  }, 400);
                  return;
                }

                this.addToCart(formData);
              } else {
                this.addToCart(formData);
              }
            })
            .catch(error => {
              console.error('Error fetching cart data:', error);
              this.submitBtn.removeAttribute('aria-disabled');
            });



    }

    async addToCart(formData) {
      let sections = 'cart-icon-bubble';
      let variantId = +formData.get('id');
      let quantity = formData.get('quantity') ? +formData.get('quantity') : 1;
      let properties = {};

      this.form.querySelectorAll('[name^="properties["]').forEach(input => {
        const propertyName = input.name.replace('properties[', '').replace(']', '');
        properties[propertyName] = input.value;
      });
      properties = Object.keys(properties).length ? properties : undefined;


      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);
      let payload = {sections};
      let items = [];
      //add sub item if formData has sub_product_id
      if (formData.has('sub_product_id') && formData.get('sub_product_id')) {
        items.push({id: +formData.get('sub_product_id'), quantity});
      }
      let item = {id: variantId, quantity};
      if (properties) {
        item.properties = properties;
      }
      // items.push({id: variantId, quantity});
      items.push(item);

      payload.items = items;

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(`${theme.routes.cartAdd}.js`, fetchRequestOpts);
        const data = await response.json();

        if (data.status) this.setErrorMsgState(data.description);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                  data,
                  !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) cartItems.refreshCart();
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
            (item) => item.variant_id === variantId
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: variantId,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === quantity)
                  ? itemInOldCart.quantity : quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: variantId
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    updateSubProductInput() {
      const container = this.closest('.js-product') || this.closest('quick-add-drawer');
      const variantPicker = container ? container.querySelector('variant-picker') : null;
      if (variantPicker) {
        const selectedOptions = this.getSelectedOptions(variantPicker);
        const subInput = this.form.querySelector('input[name="sub_product_id"]');
        const dataEl = variantPicker.querySelector('[type="application/json"]');
        const data = dataEl ? JSON.parse(dataEl.textContent) : null;
        let subInputValue = '';
        if (selectedOptions) {
          data.product.options.forEach((e, i) => {
            if ((e === 'Level' || e === '수준' || e === '等级') && selectedOptions[i] && window.DOG_SUB_CONFIG[selectedOptions[i]]) {
              subInputValue = window.DOG_SUB_CONFIG[selectedOptions[i]];
            }
          });
        }
        subInput.value = subInputValue;
      }
    }
 
    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions(variantPicker) {
      const selectedOptions = [];
 
      variantPicker.querySelectorAll('.option-selector').forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          selectedOptions.push(selector.querySelector('input:checked').value);
        }
      });
 
      return selectedOptions;
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }
  }

  customElements.define('product-form', ProductForm);
}
